import { render, staticRenderFns } from "./frameMirror.vue?vue&type=template&id=566c2235&scoped=true&"
import script from "./frameMirror.vue?vue&type=script&lang=js&"
export * from "./frameMirror.vue?vue&type=script&lang=js&"
import style0 from "./frameMirror.vue?vue&type=style&index=0&id=566c2235&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c2235",
  null
  
)

export default component.exports